import styled from "styled-components";


export const ListViewStyle = styled.div<{
  $marginTop?: string;
  $marginBottom?: string;
  $height?: number;
}>`
  width: 100%;
  height: auto;
  max-height: ${({ $height }) => $height ?? 600}px;
  margin-top: ${({ $marginTop }) => $marginTop || "0"};
  margin-bottom: ${({ $marginBottom }) => $marginBottom || "0"};   
  overflow-y: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  padding-bottom: 20px;
  gap: 16px;
  
`;

export const ListViewItemStyle = styled.div`
  width: 380px;
  height: auto; 
  padding: 0;
  margin: 0;
  @media (max-width: 768px) {
    width: 100%;    
    padding: 0;
    margin: 0;
  } 
`;